import { Box, Spinner } from '@chakra-ui/react'

const LoadingComponents = ({ loading }) => {
  return (
    <>
      {loading && (
      <Box
        alignItems='center'
        display='flex'
        flexDirection='column'
        h='100vh'
        justifyContent='center'
        w='100vw'
      >
        <Spinner
          color='orange'
          emptyColor='gray.200'
          size='xl'
          speed='0.75s'
          thickness='4px'
        />
      </Box>
      )}
    </>
  )
}

export default LoadingComponents
